<template>
    <div id="alertWl" v-show="isClose">
        <div style="display: flex;padding: 10px 10px 6px 10px;color:#fff;background: red;">
            <h4>
                通知提醒
            </h4>
            <div style="margin-left: auto;">
                <Button type="text" title="最小化" icon="md-remove" @click="min" size="small" ghost></Button>
                <Button type="text" title="最大化" icon="md-phone-landscape" @click="max" size="small" ghost></Button>
                <Button type="text" title="关闭" icon="md-close" @click="close" size="small" ghost></Button>

            </div>

        </div>
        <Table size="small" v-show="isMax" border :columns="columns" :data="tableData"
            no-data-text="<div class='table-no-data'></div>" :height="300">

        </Table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isMax: true,
            isClose: true,
            tableData: [],
            columns: [
                {
                    type: 'index',
                    width:70
                },
                {
                    title: '通知类型',
                    key: 'myLabel'
                },
                {
                    title: '车牌号',
                    key: 'carNo'
                },
                {
                    title: '驾驶员',
                    key: 'driverName'
                },
                {
                    title: '到期时间',
                    key: 'expireTime2'
                },
                {
                    title: '内容',
                    key: 'prompt'
                }
            ],
            searchItem: {

            }
        }
    },
    methods: {
        ///expirationNotice/statistics
        min() {
            this.isMax = false;
        },
        max() {
            this.isMax = true;
        },
        close() {
            this.isClose = false;
        },
        getList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-tmsx-server-web/expirationNotice/statistics",
                data: this.searchItem,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                //console.log('报警数据', res);
                this.total = res.data.data.total;
                var data = res.data.data;
                let obj = {
                    annualAudit: '车辆年审',
                    commercialInsurance: '车辆商业险',
                    compulsoryInsurance: '车辆交强险',
                    driverLicense: '司机驾驶证',
                    vehicleLicense: '司机行驶证',
                }
                let arr=[]
                for (const i in obj) {
                    for (let j = 0; j < data[i].length; j++) {
                        data[i][j].myLabel=obj[i];
                        data[i][j].expireTime2=this.utils.time(data[i][j].expireTime,'yymmdd');
                        arr.push(data[i][j]);
                    }
                }
                //console.log(4455,arr);
                this.tableData = arr;

            });
        },
    },
    mounted() {
        this.getList();
    }
}
</script>
<style scrope>
#alertWl {
    width: 600px;
    background: #fff;
    border: solid 2px red;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 50;
}
</style>


// WEBPACK FOOTER //
// src/components/xiyang/common/alertWl.vue